import faker from 'faker';
import _set from 'lodash/set';
import _get from 'lodash/get';
import debugDependency from 'debug';
import {
  DEBUG_LEVELS,
  debugBuilder,
  isVerboseMode,
  MOCKED_MERCHANT_NAMESPACE,
  setDebugMode,
} from '../tools/debug';

const debug = debugBuilder(debugDependency)(MOCKED_MERCHANT_NAMESPACE);

export class MockedMerchant {
  constructor(props, verbose = true) {
    const logLevel = verbose ? DEBUG_LEVELS.LOG : DEBUG_LEVELS.INFO;
    setDebugMode(debugDependency)(debug, logLevel);
    this.state = {
      ...props,
    };
  }

  result() {
    const timestamp = new Date().toISOString();
    return {
      timestamps: {
        createdAt: timestamp,
        lastModifiedAt: timestamp,
      },
      isNgMerchant: true,
      ...this.state,
    };
  }

  applyProperty(prop, path) {
    if (path && path.length) {
      _set(this.state, path, prop);
    } else {
      debug.error('applyProperty requires a path');
    }
    return this;
  }

  spreadProperty(prop, path) {
    if (path && path.length) {
      const current = _get(this.state, path);
      _set(this.state, path, {
        ...current,
        ...prop,
      });
    } else {
      this.state = {
        ...this.state,
        ...prop,
      };
    }
    return this;
  }

  spreadArrayProperty(prop, path) {
    if (path && path.length) {
      const current = _get(this.state, path, []);
      _set(this.state, path, [...current, ...prop]);
    } else {
      debug.error('spreadArrayProperty requires a path');
    }
    return this;
  }
}

export function applyStepsWithConfig(applyStepConfig) {
  const applySteps = steps => {
    const mock = new MockedMerchant({}, isVerboseMode());
    steps.forEach(stepName => {
      const config = applyStepConfig[stepName];
      if (!config) {
        debug.warn(`getMerchantWithSteps no data found for step ${stepName}`);
      } else {
        mock[config.method](config.value, config.path);
      }
    });
    debug.log(`getMerchantWithSteps for ${JSON.stringify(steps)}`, mock);
    return mock.result();
  };

  applySteps.availableSteps = Object.keys(applyStepConfig);

  return applySteps;
}

export function fakeOnboardingStatus() {
  const timestamp = new Date().toISOString();
  const onboardingStatuses = {
    NOT_STARTED: {
      status: 'NOT_STARTED',
    },
    TRANSACTION_DETAILS_STARTED: {
      status: 'TRANSACTION_DETAILS_STARTED',
    },
    TRANSACTIONS_REVIEW_MANUAL: {
      status: 'TRANSACTIONS_REVIEW_MANUAL',
    },
    TRANSACTIONS_ENABLED: {
      status: 'TRANSACTIONS_ENABLED',
      timestamps: {
        createdAt: timestamp,
        lastModifiedAt: timestamp,
        transactionsRequestedAt: timestamp,
      },
    },
  };

  return {
    notStarted: {
      value: onboardingStatuses.NOT_STARTED,
      method: 'spreadProperty',
      path: null,
    },
    transactionsStarted: {
      value: onboardingStatuses.TRANSACTION_DETAILS_STARTED,
      method: 'spreadProperty',
      path: null,
    },
    transactionsReview1: {
      value: onboardingStatuses.TRANSACTIONS_REVIEW_MANUAL,
      method: 'spreadProperty',
      path: null,
    },
    transactionsEnabled: {
      value: onboardingStatuses.TRANSACTIONS_ENABLED,
      method: 'spreadProperty',
      path: null,
    },
  };
}

export function fakeBankAccount(data) {
  return {
    id: 201663,
    type: 'IBAN',
    data: {
      accountHolder: `${faker.name.firstName()} ${faker.name.lastName()}`,
      routingNumber: 'SOGEDEFFXXX',
      ...data,
    },
    // TODO(cypress-v2): remove these properties below,
    // these is the "old" bankAccount which doesn't match the BE model
    // to avoid refactoring every test on the first iteration,
    // we provide these props here so whatever test that uses the old
    // model can still work
    accountHolder: `${faker.name.firstName()} ${faker.name.lastName()}`,
    routingNumber: 'SOGEDEFFXXX',
    ...data,
  };
}
export function fakeStakeholder(role = 'OWNER', country = 'DE') {
  const fakePersonalId = country =>
    ({
      US: '123-44-1234',
      SE: '19920101-1234',
      FI: '010192-123A',
      DK: '010192-1212',
      NO: '01019212345',
      IT: 'CLDNRG84L58H501R',
      ES: '12345678L',
    }[country] || 'FK12344');

  return {
    roles: [role],
    type: 'PERSON',
    data: {
      firstName: faker.name.firstName(),
      lastName: faker.name.lastName(),
      dateOfBirth: '1992-01-01',
      address: {
        street: faker.address.streetAddress(),
        postalCode: faker.address.zipCode(),
        city: 'Berlin',
        region: country === 'US' ? 'NY' : 'Berlin',
        country,
      },
      ssn: country === 'US' ? '123-44-1234' : null,
      personalId: fakePersonalId(country),
    },
  };
}

export function fakeMerchantRegistrationAccount() {
  const firstName = faker.name.firstName();
  const lastName = faker.name.lastName();
  const label = faker.datatype.uuid();
  const email = `${firstName}.${lastName}+${label}@klarna.com`;
  return {
    firstName,
    lastName,
    email,
    password: faker.internet.password(),
    phone: faker.phone.phoneNumber(),
  };
}
